import { LanguageMetadata, TestMetadata } from 'api/API';

/*
 * Based on the users set region, it will return the correct device description.
 * If no region specific description is found, default to base description.
 */
export const getRegionSpecificDescription = (
  region: string,
  languageMetadata: LanguageMetadata | null,
): string | null => {
  switch (region) {
    case 'AUS':
      return languageMetadata?.description_english ?? null;
    case 'JPN':
      return languageMetadata?.description_japanese ?? null;
    default:
      return null;
  }
};

export const getRegionSpecificAIR = (region: string, partTestMetadata: TestMetadata | null): string | null => {
  switch (region) {
    case 'AUS':
      return partTestMetadata?.additional_inspection_english ?? null;
    case 'JPN':
      return partTestMetadata?.additional_inspection_japanese ?? null;
    default:
      return null;
  }
};
